import { Injectable } from '@angular/core';
import { AsyncValidator, ValidationErrors, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { PhraseTypeSettingsService } from 'src/core/services/settings/phrase-type-settings.service';

@Injectable({ providedIn: 'root' })
export class CustomPhraseTypeValidator implements AsyncValidator {
  id: number | null;

  constructor(private service: PhraseTypeSettingsService) {}

  validate(
    formControl: FormControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    const id = this.id == null ? null : this.id;
    const value = formControl.value;

    return this.service.getCustomPhraseTypeByName(value).pipe(
      map(
        response => {
          return response !== null && response.id !== +id ? { nameAlreadyInUse: true } : null;
        },
        catchError(() => {
          return null;
        })
      )
    );
  }
}
